import Backbone from 'backbone';
const $ = Backbone.$;

module.exports = Backbone.View.extend({
  tagName: 'div',

  events: {
    click: 'disablePropagation'
  },

  initialize(o = {}) {
    _.bindAll(this, 'openChanged');
    let model = this.model;
    this.config = o.config || {};
    this.horizontal = o.horizontal ? o.horizontal : 'right';
    this.pfx = this.config.stylePrefix || '';
    this.target = o.target || {};
    this.direction = o.direction;
    this.contentView = o.contentView;
    this.listenTo(model, 'change:open', this.openChanged);
  },

  close() {
    const { model } = this;
    model.set('open', false);
    model.trigger('close');
  },

  open() {
    const { model } = this;
    model.set('open', true);
  },

  show() {
    this.$el.css('display', 'block');
  },

  hide() {
    this.$el.remove();
    this.overlay && this.overlay.remove();
  },

  openChanged() {
    const isOpen = this.model.get('open');
    if (isOpen) {
      this.show();
    } else {
      this.hide();
    }
  },

  disablePropagation(e) {
    e.stopPropagation();
  },

  renderContent() {
    const { model, $el } = this;
    if (this.contentView) {
      $el.append(this.contentView.render().el);
    }
  },

  render() {
    const self = this;
    const { model, el, pfx, config, $el } = this;
    const top = model.get('top');
    const maxHeight = model.get('maxHeight');
    const body = config.canvas.frameBody;
    const width = model.get('width');
    const height = model.get('height');
    const bgcolor = model.get('bgcolor');
    el.className = `${pfx}modalbox`;
    $el.css({ width: width + 'px', height: height + 'px' });

    this.overlay = $(
      `<div style="width:${config.width -
        40}px;height:${maxHeight}px;background-color:${bgcolor};" class="${pfx}modaloverlay"></div>`
    );
    this.overlay.on('click', function(e) {
      self.close();
    });

    this.renderContent();

    body.append(this.overlay);
    body.append(el);

    return this;
  }
});
